export enum UserAccess {
  BATCH = 'BATCH',
  SalesLandingPage = 'salesLandingPage',
}
